import { render, staticRenderFns } from "./TrailEditorDialog.vue?vue&type=template&id=180b3f08&scoped=true"
import script from "./TrailEditorDialog.vue?vue&type=script&lang=js"
export * from "./TrailEditorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180b3f08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('180b3f08')) {
      api.createRecord('180b3f08', component.options)
    } else {
      api.reload('180b3f08', component.options)
    }
    module.hot.accept("./TrailEditorDialog.vue?vue&type=template&id=180b3f08&scoped=true", function () {
      api.rerender('180b3f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/TrailEditorDialog.vue"
export default component.exports